import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useCommandPalette } from "../../contexts/commandPalette/Context";

const detectMetaKey = (): string => {
  if (typeof navigator === "undefined") return "Ctrl";
  return navigator.platform.toLowerCase().includes("mac") ? "⌘" : "Ctrl";
};

export const CommandPaletteTrigger = () => {
  const { open } = useCommandPalette();
  const [metaKey, setMetaKey] = useState("Ctrl");

  useEffect(() => {
    setMetaKey(detectMetaKey());
  }, []);

  return (
    <button
      type="button"
      onClick={open}
      aria-label="Abrir command palette"
      className="flex items-center gap-2 h-8 px-3 rounded-md border border-global-primary bg-global-overlay-secondary text-global-tertiary hover:text-global-primary hover:bg-global-overlay transition-colors text-sm cursor-pointer"
    >
      <Search aria-hidden className="h-3.5 w-3.5" />
      <span className="hidden md:inline">Buscar…</span>
      <kbd className="hidden md:inline-flex items-center gap-0.5 px-1.5 py-0.5 text-2xs font-medium text-global-muted bg-global-primary border border-global-secondary rounded">
        {metaKey}K
      </kbd>
    </button>
  );
};
